import {Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../../template/template.component";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-brand-logos',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './brand-logos.component.html',
  styleUrl: './brand-logos.component.css'
})
export class BrandLogosComponent extends TemplateComponent implements OnInit{


  brands:any[];
  ngOnInit() {
    this.brands = JSON.parse(this.global.getMainData()['main-page']['data'])['brands'];
    setTimeout(()=>{
      this.brands = JSON.parse(this.global.getMainData()['main-page']['data'])['brands'];
    },1000)
  }

}
